/**** Open Cart Drawer Function ****/
function openCartDrawer() {
    $('.cart_drawer').addClass('active');
    $('body').addClass('overflow-hidden');
}

/**** Close Cart Drawer Function ****/
function closeCartDrawer() {
    $('.cart_drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');
}
/**** Progreshbar animation ****/
function animateProgressBars(ctx = document) {
  $(ctx).find('.bar-container .bar-fill').each(function () {
    const target = parseFloat($(this).attr('style').match(/width:\s*([\d.]+)%/)[1] || 0);
    $(this).css({ width: 0 }); // Reset first
    setTimeout(() => $(this).css({ width: target + '%' }), 50);
  });
}

/**** Update Single Item Quantity Function ****/
function updateQuantity(lineItemKey, quantity, input, sections) {
  let formData = {
    'id': lineItemKey,
    'quantity': quantity,
  };
  if (!sections) {
    formData.sections = getSectionsToRender().map((section) => section.section);
  }
     
  fetch('/cart/change.js?item_quantity_update', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(responseJson => {
    if(responseJson.description) {
      if(input) input.val(quantity - 1);
      showNotification(window.notificationErrorTemplate(responseJson.description));
      return;
    }
    console.log("responseJson ",responseJson);
    updateCartDrawer(responseJson);
  })
 
}

/**** Update Cart Drawer HTML Function ****/
function updateCartDrawer(response) {
  if (!response) return;
  var cart_drawer_html = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
  var sourceElement = cart_drawer_html.querySelector('#CartDrawer');

  // var itemCount = sourceElement.querySelector('.cart-drawer-content').getAttribute('data-item-count');
  
  var getSections_Render = getSectionsToRender();
  $.each(getSections_Render, function(key, section) {
   
    const elementToReplace = $('#'+section.id).find(section.selector) || $('#'+section.id);
    if(elementToReplace.length > 0) {
      elementToReplace.html(getSectionInnerHTML(response.sections[section.section], section.selector))
    }
  });
  animateProgressBars('#CartDrawer');
}

/**** Get HTML Functions ****/
function getSectionInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}

function getSectionsToRender() {
  return [
    {
      id: 'CartDrawer',
      section: 'cart-drawer',
      selector: '.cart-drawer-form-wrapper',
    },
  ];
}



$(document).ready(function (){
    /**** Mini Drawer on plus and minus click quantity update ****/
    $(document).on("click", ".quantity-down.minus, .plus.quantity-up", function (e) {
      e.preventDefault();
      var input = $(this).closest(".quantity").find(".cart-item__quantity-input");
      console.log("input:: ", input);
      var oldVal = input.val();
      var newVal = 0;
      if ($(this).attr('data-name') == 'plus') {
          newVal = parseInt(oldVal) + 1;
      } else {
          newVal = parseInt(oldVal) - 1;
      }
      console.log("input newVal:: ", newVal);
      input.val(newVal);

        var line_item_key = $(this).parents('.cart-item ').attr('data-key');
        var qty = parseInt(input.val());
        updateQuantity(line_item_key, qty, input);
    });

    /**** Mini Drawer on remove button click item remove ****/
    $(document).on("click", ".cart-item__remove ", function (e) {
        e.preventDefault();
        $(this).addClass('loading__spinner');
        var line_item_key = $(this).parents('.cart-item').attr('data-key');
        updateQuantity(line_item_key, 0);
    });

    /***** Open cart drawer */
    $(document).on("click", "#cart-icon--bubble", function () {
      openCartDrawer();
    });

    /***** Close cart drawer */  
    $(document).on("click", ".drawer__close, .cart-drawer__overlay", function () {
      closeCartDrawer();
    });
    
    // When "Add to Cart" button is clicked
    $(document).on("click", ".product-purchase-form button[type='submit']", function (e) {
      e.preventDefault();

      let $btn = $(this);
      let $form = $btn.closest(".product-purchase-form");

      let defaultText = $btn.text();
      $btn.text("Adding...").prop("disabled", true);

      let variantID = parseInt($form.find('input[name="id"]').val() || $form.find('select[name="id"]').val() || 0);

      let qty = parseInt($form.find('input[name="quantity"]').val()) || 1;

      if (!variantID) {
          alert("Please select a product variant.");
          $btn.text(defaultText).prop("disabled", false);
          return;
      }

      let items = [{ id: variantID, quantity: qty }];

      fetch('/cart/add.js?product_add_to_cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items, sections: getSectionsToRender().map(s => s.section) })
      })
      .then(res => res.json())
      .then(data => {
          if (data.description) { 
              showNotification(window.notificationErrorTemplate(data.description));
          } else {
              updateCartDrawer(data); 
              openCartDrawer(); 
          }
          $btn.text(defaultText).prop("disabled", false);
      })
      .catch(err => {
          console.error("Add to cart error:", err);
          $btn.text(defaultText).prop("disabled", false);
      });
    });

    // ================ upsell Add to car code Start =================== 
    $(document).on("click", ".cart-upsell-btn", function (e) {
      e.preventDefault();

      let $btn = $(this);
      let defaultText = $btn.text();
      $btn.text("Adding...").prop("disabled", true);

      let variantID = parseInt($btn.val());
      if (!variantID) {
          console.error("Variant ID not found!");
          $btn.text(defaultText).prop("disabled", false);
          return;
      }

      let items = [{ id: variantID, quantity: 1 }];

      fetch('/cart/add.js?product_add_to_cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              items,
              sections: getSectionsToRender().map(s => s.section)
          })
      })
      .then(res => res.json())
      .then(data => {
          if (data.status && data.status !== 200) {
              console.error("Error:", data.description);
              alert(data.description);
          } else {
              updateCartDrawer(data);
          }
          $btn.text(defaultText).prop("disabled", false);
      })
      .catch(err => {
          console.error("Upsell Add to Cart Error:", err);
          $btn.text(defaultText).prop("disabled", false);
      });
    });

});
